export const environment = {
    production: false,
    backend_domain:"https://stagapi.archoftraits.com/",
    web_app_url:"https://stag.archoftraits.com/",
    version: '2.4.1'
};
